import { render, staticRenderFns } from "./HealthBars.vue?vue&type=template&id=7bc36d71&"
import script from "./HealthBars.vue?vue&type=script&lang=js&"
export * from "./HealthBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports